import { GET_LAST_CHOOSEN_KEEP_SAFE_FORM_DATA } from "../actions.type";

const getLastChooseKeepSafeFormDataState = () => {
	return {
		last_keep_safe_form_items:{}
	}
};

const state = getLastChooseKeepSafeFormDataState();
const getters = {
	getLastChoosenKeepSafeFormDetail(state) {
		return state.last_keep_safe_form_items;
	}
};

const mutations = {
	setLastChoosenKeepSafeFormDetail (state, data) {
		state.last_keep_safe_form_items = data
	},
};

const actions = {
	[GET_LAST_CHOOSEN_KEEP_SAFE_FORM_DATA](context, data){
		context.commit('setLastChoosenKeepSafeFormDetail',data);
	},
};

export default {
	getters,
	actions,
	mutations,
	state
}
